import { ref, onMounted, onUnmounted } from 'vue';
import { io } from 'socket.io-client';

let socket = null;
const isConnected = ref(false);
const currentPrice = ref(null);
const roundInfo = ref(null);

// 이벤트 리스너 큐 (socket 연결 전 등록된 리스너들)
const pendingListeners = [];

export const useSocket = () => {
  const connect = (userId, nickname, avatar) => {
    if (socket?.connected) {
      // console.log('[Socket] Already connected');
      return socket;
    }

    // Socket.io 서버 연결 (Apache 프록시 통해)
    socket = io({
      path: '/socket.io/',
      transports: ['websocket', 'polling'],
      reconnection: true,
      reconnectionDelay: 1000,
      reconnectionAttempts: 5
    });

    socket.on('connect', () => {
      isConnected.value = true;

      // 대기 중이던 이벤트 리스너 등록
      if (pendingListeners.length > 0) {
        pendingListeners.forEach(({ event, callback }) => {
          socket.on(event, callback);
        });
        pendingListeners.length = 0; // 큐 비우기
      }

      // 사용자 정보 전송 (로그인한 경우)
      if (userId) {
        socket.emit('chat:join', {
          userId,
          nickname,
          avatar
        });
      }
    });

    socket.on('disconnect', (reason) => {
      isConnected.value = false;
    });

    socket.on('connect_error', (error) => {
      isConnected.value = false;
    });

    return socket;
  };

  const disconnect = () => {
    if (socket) {
      socket.disconnect();
      socket = null;
      isConnected.value = false;
    }
  };

  const emit = (event, data) => {
    if (socket && isConnected.value) {
      socket.emit(event, data);
    }
  };

  const on = (event, callback) => {
    if (socket && socket.connected) {
      socket.on(event, callback);
    } else {
      pendingListeners.push({ event, callback });
    }
  };

  const off = (event, callback) => {
    if (socket) {
      socket.off(event, callback);
    }
  };

  const updateUser = (userId, nickname, avatar) => {
    if (socket && isConnected.value && userId) {
      socket.emit('chat:join', {
        userId,
        nickname,
        avatar
      });
    }
  };

  return {
    socket,
    isConnected,
    currentPrice,
    roundInfo,
    connect,
    disconnect,
    emit,
    on,
    off,
    updateUser
  };
};
